import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [recoveryUrl, setRecoveryUrl] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      if (data.founder_recovery_url) {
        setRecoveryUrl(data.founder_recovery_url);
      }
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-12" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <p className="label-eyebrow mb-3">Account recovery</p>
        <h1 className="font-serif text-4xl mb-3 leading-tight">Reset your password</h1>
        {sent ? (
          <div className="card-soft p-5 mt-6" data-testid="forgot-sent">
            <p className="font-serif text-xl mb-2">Check your inbox</p>
            <p className="text-sm" style={{ color: "var(--text-2)" }}>
              If an account with <strong>{email}</strong> exists, we&rsquo;ve sent a reset link. It expires in 1 hour.
            </p>
            {recoveryUrl && (
              <div className="mt-5 p-4 rounded-2xl" style={{ background: "#FBF4F0", border: "1px solid #ECDCD3" }} data-testid="founder-recovery-link">
                <p className="label-eyebrow mb-2" style={{ color: "var(--warning)" }}>Founder recovery</p>
                <p className="text-sm mb-3" style={{ color: "var(--text)" }}>
                  Email isn&rsquo;t configured yet, so here is your reset link. Click it to choose a new password.
                </p>
                <a
                  href={recoveryUrl}
                  className="btn-primary text-sm inline-block"
                  data-testid="founder-recovery-button"
                >
                  Open reset link
                </a>
              </div>
            )}
            <p className="text-xs mt-4" style={{ color: "var(--text-2)" }}>
              Don&apos;t see it? Check spam, or wait a minute and try again.
            </p>
          </div>
        ) : (
          <>
            <p className="mb-6" style={{ color: "var(--text-2)" }}>
              Enter your email and we&apos;ll send you a link to choose a new password.
            </p>
            <form onSubmit={submit} className="space-y-4">
              <input
                className="input-soft"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
                data-testid="forgot-email-input"
              />
              <button type="submit" className="btn-primary w-full" disabled={loading} data-testid="forgot-submit">
                {loading ? "Sending…" : "Send reset link"}
              </button>
            </form>
          </>
        )}
        <p className="mt-8 text-sm">
          <Link to="/auth" className="underline" style={{ color: "var(--brand)" }}>← Back to sign in</Link>
        </p>
      </div>
    </main>
  );
}
